<template>
    <div class="associated">
        <emojis/>
        <section id="section_I" class="relative" :style="{backgroundImage: 'url(' + require('@/assets/associated/bg-sect-1.png') + ')'}">
            <div class="container content flex">
                <div class="flex">
                    <div class="animated bounceInLeft ">
                        <h1 class=" big-title color-white f-w-700 h1 mb-5">Seu <br class="show-mobile"> momento <br> é agora!</h1>
                        <a href="" v-scroll-to="'#scrollForms'" class="fdfd btnMyFran btnMyFranI show-desktop our-btn-a bg-color-357EB8 color-white f-w-700">Quero a minha franquia</a>
                    </div>
                </div>
                <div class="animated bounceInRight absolute notebook">
                    <img class="img-responsive" src="@/assets/associated/notebook.png" alt="notebook.png">
                </div>
                <a href="" v-scroll-to="'#scrollForms'" class="btnMyFran btnMyFranI show-mobile our-btn-a bg-color-357EB8 color-white f-w-700">Quero a minha franquia</a>
            </div>                
        </section>
        <section id="section_II">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-12 flex j-c-center">
                        <div class="balcony flex j-c-center">
                            <img class="img-responsive" src="@/assets/associated/balcony.png" alt="balcony">
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-12">
                        <h2 class="color-2474B2 big-title f-w-700">
                            Saia na Frente! <br>
                            Empreenda na área de tecnologia com a primeira Franquia Fintech do Brasil.
                        </h2>
                        <p class="toDescriptions color-707070">
                            <span class="font-weight-bold text-uppercase" style="font-size:18px;">Invista no futuro: abra sua Própria franquia de tecnologia!</span> <br>
                            Invista na franquia de conveniência 
                            digital que mais cresce no Brasil e 
                            multiplique as suas receitas. Criamos um 
                            modelo de negócio para ajudar os seus 
                            clientes a resolverem tudo em um só 
                            lugar e gerar uma nova fonte de renda 
                            para você! São mais de 1.000 serviços e digitais, e contamos com mais de 50 parceiros conveniados no nosso HUB de atendimento.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section id="section_III" class="relative" :style="{backgroundImage: 'url(' + require('@/assets/associated/bg-sect-2.png') + ')'}">
            <div class="img-man-winner absolute show-desktop">
                <img class="img-responsive" src="@/assets/associated/man-winner.png" alt="man-winner">
            </div>
            <div class="container relative">
                <div class="row">                    
                    <div class="col-lg-8 col-md-12 offset-lg-4 expressive-results j-c-center">
                        <h2 class="mt-5 big-title color-white f-w-700  toCapitalize">Resultados expressivos</h2>
                    </div>
                    <div class="col-lg-8 col-md-12 offset-lg-4 circles flex j-c-center">
                        <div class="row ">
                            <div class="col-lg-6 col-md-12 flex j-c-center first-circle">
                                <div class="flex-j-c-center text-center circle-I investment relative">
                                    <div class="circle-II flex j-c-center">
                                        <div>
                                            <h3 class="color-white little-title toUpperCase text-center"> <strong>Investimento Total</strong></h3>
                                            <!-- <h4 class="color-white text-center f-w-700" style="position: relative; z-index:4;">R$ 24.500,00*</h4> -->
                                            <h4 class="color-white text-center f-w-700" style="position: relative; z-index:4;">R$ 50.000,00*</h4>
                                            <h5 class="color-white ajusting ajust">* Estimativa conforme tamanho de loja</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 flex j-c-center second-circle ">
                                <div class="flex-j-c-center text-center this-ajusting-mobile circle-I investment relative">
                                    <div class="circle-II flex j-c-center">
                                        <div>
                                            <h3 class="color-white little-title toUpperCase"><strong>Lucratividade Média</strong></h3>
                                            <h4 class="color-white ajus-h4 text-center f-w-700 mb-3">50% Mensais</h4>
                                            <!-- <h3 class="color-white ajus-h3 little-title toUpperCase ">mensais</h3> -->
                                            <!-- <h5 class="color-white second-h5 ajusting">* Franquia com 2 terminais</h5> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p class="toDescriptions color-white services texts">Por ser uma franquia de serviços digitais e financeiros, com a Ponto Fácil você não tem custos com compras de produtos, não precisa fazer controle de estoques e pode focar no que mais importa: <strong>atrair novos clientes e gerar receitas para o seu negócios!</strong> </p>
                            </div>
                            <div class="col-md-12 show-desktop">
                                <h2 class="mb-5 color-white medi-tittle">Retorno <strong>rápido</strong> do seu investimento!</h2>
                            </div>
                            <div class="col-md-12 returning-investiment show-mobile">
                                <h2 class="mb-5 color-white medi-tittle">Retorno <strong>rápido</strong> <br> do seu investimento!</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="absolute btn-Fran text-center">
                    <div class="btnMyFran show-desktop">
                        <a v-scroll-to="'#section_VIII'" class="our-btn-a our-btn-a2 bg-color-F38235 color-white f-w-700">Quero a minha franquia agora!</a>
                    </div>
                    <div class="btnMyFran show-mobile flex j-c-center">
                        <a v-scroll-to="'#section_VIII'" class="our-btn-a our-btn-a2 bg-color-F38235 color-white f-w-700">Quero a <br> minha franquia agora!</a>
                    </div>
                </div>
            </div>
        </section>

        <section id="section_IV">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="col-lg-6 col-md-12 girl-winner flex j-c-center show-mobile">
                            <img class="img-responsive" src="@/assets/associated/girl-winner.png" alt="girl-winner">
                        </div>
                        <div class="flex j-c-center h-100 ajusting-girl-winner">                            
                            <div class="">
                                <h2 class="big-title f-w-700 color-2474B2">
                                    Perfeito para todas as regiões do
                                    país e cabe em qualquer estabelecimento
                                </h2>
                                <p class="toDescriptions color-707070">
                                    Nossas franquias vão desde franquias pocket, quiosque e até 
                                    loja física, são vários modelos 
                                    e tamanhos para que você possa ter uma Ponto Fácil em qualquer lugar!
                                    É a segurança que seu investimento precisa, 
                                    com modelos de negócio de acordo com o seu perfil.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 girl-winner flex j-c-center show-desktop">
                        <img class="img-responsive" src="@/assets/associated/girl-winner.png" alt="girl-winner">
                    </div>
                </div>
            </div>
        </section>

        <section id="section_V">
            <div :style="{ backgroundImage: 'linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0.7) 100%), url(' + require('@/assets/associated/bg-sect-5.png') + ')' }">
                <media-play :title="'Nós já estamos nas casas lotéricas!'" :linkVideo="'https://www.youtube.com/embed/mOAfBVRepSc'"/>
            </div>
            <div class="btn-Fran2 text-center">
                    <div class="btnMyFran show-desktop">
                        <a v-scroll-to="'#section_VIII'" class="our-btn-a our-btn-a2 bg-color-F38235 color-white f-w-700">Quero a minha franquia agora!</a>
                    </div>
                    <div class="btnMyFran show-mobile flex j-c-center">
                        <a v-scroll-to="'#section_VIII'" class="our-btn-a our-btn-a2 bg-color-F38235 color-white f-w-700">Quero a <br> minha franquia agora!</a>
                    </div>
            </div>
        </section>

        <section id="section_VI">
            <div class="container tables">
                <div class="col-md-6 notebook-dados relative d-block d-sm-none">
                    <img class="img-responsive absolute" src="@/assets/associated/notebook-dados.png" alt="notebook-dados">
                </div>
                <div class="content row">
                    <div class="col-md-6 notebook-dados relative show-desktop">
                        <img class="img-responsive absolute" src="@/assets/associated/notebook-dados.png" alt="notebook-dados">
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="flex j-c-center h-100">
                            <div>
                                <h2 class="flex-end m-title text-lg-right f-w-700 color-2474B2 show-desktop">
                                    Você no controle de tudo!
                                </h2>
                                <h2 class="m-title flex j-c-center f-w-700 color-2474B2 show-mobile">
                                    Você no <br> controle de tudo!
                                </h2>
                                <p class="toDescriptions color-707070">
                                    <span class="font-weight-bold text-uppercase">Investir em um negócio focado em tecnologia e inovação é investir para o longo prazo!</span> <br><br>
                                    Desenvolvemos um sistema de atendimento e gestão personalizado para te apoiar nessa jornada.<br><br>
                                    <span class="font-weight-bold text-uppercase">Empreenda de maneira sólida e estruturada!</span><br><br>
                                    E você recebe também um kit completo de Manuais e Guias Operacionais da Franquia, Plano de Negócios de 5 anos
                                    e contará com um suporte ativo e exclusivo no dia a dia do seu negócio através da nossa equipe de atendimento do <span class="font-weight-bold color-blue">Canal Fácil</span>.
                                </p>
                                <div class="canal-facil pull-right show-desktop">
                                    <div class="icon">
                                        <img class="img-responsive" src="@/assets/associated/icons/icon-canal-facil.png" alt="Ícone do Canal Fácil">
                                    </div>
                                </div>
                                <div class="canal-facil show-mobile flex j-c-center">
                                    <div class="icon">
                                        <img class="img-responsive" src="@/assets/associated/icons/icon-canal-facil.png" alt="Ícone do Canal Fácil">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>    

        <section id="section_VII" :style="{backgroundImage: 'url(' + require('@/assets/associated/bg-sect-2.png') + ')'}">
            <advantages-of-being-an-associate/>
        </section>

        <section id="section_VIII" :style="{backgroundImage: 'url(' + require('@/assets/associated/bg-sect-8.png') + ')'}">
            <Form-have-a-franchisee />
        </section>
    </div>
</template>

<style scoped>
    .ajust {
        width: 84%;
        margin: 0 auto;
    }
    .tables {
       
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .texts p {
        top: 94px;
        position: relative;
        width: 76%;
        margin-bottom: 107px;
    }

    .services {
        width: 90%;
        margin: 20px auto;
    }
    @media (min-width:765px) { 
        .tables {
             min-height: 92vh;
        }
    }
    @media (min-width:990px) {
    .services {
        width: 90%;
        margin: 20px auto 20px 0px;
    }
        
    }
    .btn-Fran2 {
        margin-top: -20px;
        color: #fff;
    }
    #img_emoji
    {
        z-index: 500;
        top: 600px;
        left: 250px;
    }

    #img_emoji img {
        width: 50%;
    }

    #section_I{
        height: 100vh;
        background-size: cover;
        -o-object-fit: cover;
           object-fit: cover;
        background-position: bottom;
        background-repeat: none;
        margin-bottom: 50px;
    }

    .fdfd {
        width: 282px;
        font-size: 18px!important;
    }

    .animated{
        width: 100vw
    }

    .notebook{
        right: -600px;
        bottom: -50px
    }

    .our-btn-a{
        color: #fff;
        font-size: 22px
    }

    .our-btn-a2{
        padding: 10px 45px!important;
    }

    .notebook img{
        width: 50%;
    }

    .btnMyFranI{
        margin-top: 40px;
    }

    #section_I .content{
        padding-top: 200px;
        height: 100%;
    }

    #section_II{
        padding: 50px 0;
    }

    #section_II .balcony img{
        width: 100%;
        margin-left: -50px;
    }

    #section_II .toDescriptions{
        text-align: right;
        padding: 20px 0
    }

    #section_II h2, #section_II p{
        text-align: right;
        padding-left: 50px;
    }

    #section_III{
        margin-bottom: 50px;
    }

    #section_III .img-man-winner{
        left: 30px;
        bottom: 0;
    }

    #section_III .img-man-winner img{
        width: 75%
    }
    
    #section_III h5{
        font-size: 14px;
    }

    #section_III h4{
        font-size: 32px;
        margin: 10px 0 30px 0;
    }
    
    #section_III .ajus-h4{
        margin: 0;
    }

    #section_III .ajus-h3{
        margin-bottom: 20px;
    }

    
    .circle-I{
        border: 4px solid #E0A638;
        height: 340px;
        width: 340px;
        border-radius: 100%;
        display: flex;
        align-items: center;
    }

    .circle-II{
        margin: 20px ;
        border: 4px solid #fff;
        border-radius: 100%;
        height: 300px;
        width: 300px;
        background-color: #E0A638;
    }

    .second-circle {
        margin: -120px;
    }

    .second-circle .circle-II{
        background-color: #F38235;
        border: 4px solid #fff;
    }

    #section_III .btn-Fran{
        margin-top: -20px;
        right: 50%;
        -webkit-transform: translateX(50%);
                transform: translateX(50%);
    }

    p{
        margin-top: 30px
    }

    #section_IV .container, #section_IV .col-md-6{
        padding-bottom: 0;
    }

    .girl-winner img{
        width: 75%
    }

    #section_V > div{
        background-attachment: fixed;
        position: relative;
    }

    #section_VI .notebook-dados img{
        width: 150%;
        bottom: -200px;
        left: -30px;
    }

    #section_VI .m-title{
        font-size: 40px;
        /* padding: 80px 0 30px 0 */
    }

    #section_VI .content{
        padding: 75px 0;
    }

    #section_VI p{
        text-align: right;
    }

    #section_VII{
        padding: 100px 0;
        background-attachment: fixed;
        background-size: cover;
        background-repeat: repeat
    }

    #section_VIII{
        margin-top: -400px;
    }

    .icon img{
        width: 120px;
    }
    #section_III .btnMyFran a{
        color: #fff!important
    }


    @media only screen and (max-width: 1366px){
        .opinions > div{
            right: -20px;
        }

        .notebook img{
            width: 60%;
        }
        
        .notebook{
            right: -500px;
            bottom: -50px
        }
    }

    @media only screen and (max-width: 1024px){
        
        h1{
            font-size: 50px!important;
        }

        #section_III .img-man-winner{
            left: -75px;
        }

        #section_VIII{
            padding: 0 0 100px 0;
        }

        .notebook{
            right: -250px!important;
            bottom: 20px
        }
    }  

    @media only screen and (max-width: 992px){
        .girl-winner img{
            width: 50%;
        }
    }

    @media only screen and (max-width: 768px){
        #section_I .content{
            padding-top: 125px
        }

        #section_I{
            background: border-box;
            height: 100vh;
        }

        #section_VIII{
            margin-top: -450px;
        }

        .our-btn-a{
            font-size: 19px
        }

        .content{
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
            vertical-align: middle;
        }

        h1{
            text-align: center!important;
            width: 100%
        }

        .notebook{
            left: -60px;
            bottom: 20px
        }

        .notebook img{
            width: 100%;
        }

        .btnMyFranI{
            position: absolute;;
            bottom: -20px;            
        }

        h2, p{
            text-align: center!important;
            padding: 0!important;
        }
        
        p{
            margin-top: 50px;
        }

        #section_VI .notebook-dados img{
            position: relative;
            bottom: 0;
            margin: 20px 0;
        }

        #section_VIII{
            background-size: cover;
        }

        .this-ajusting-mobile{
            margin-top: -100px;
        }

        .circles h3{
            font-size: 16px
        }

        /* fewfewfewfe */
        
        .second-circle {
            margin: 0px;
        }

        #section_III h4{
            margin: 10px 0;
        }

        .ajusting{
            padding-top: 20px;
        }

        .expressive-results{
            padding: 80px 0 50px 0;
        }

        .returning-investiment{
            padding: 20px 0 80px 0;
            display: flex;
            justify-content: center;
        }

        .returning-investiment h2{
            font-size: 30px!important
        }

        #section_III{
            background-size: cover;
        }

        #section_III .btn-Fran{
            width: 90%;
            margin-top: -30px;
        }

        .ajusting-girl-winner{
            -webkit-box-align: initial;
                -ms-flex-align: initial;
                    align-items: initial;
        }

        .girl-winner img{
            margin: 20px 0 50px 0;
        }

        .section_V{
            background: transparent!important
        }

        #section_VI .content{
            padding: 0!important;
        }

        #section_VI .m-title{
            font-size: 30px!important
        }
    }
    @media only screen and (max-width: 1444px){
        .h1{
            font-size: 60px!important;
        }

    }

    @media only screen and (max-width: 450px){
        .notebook{
            left: 0;
            bottom: -29px;
        }

        .notebook img{
            width: 100%;
        }
        #section_VIII{
            margin-top: -490px;
        }
    }

    @media only screen and (max-width: 360px){
        .notebook{
            left: 30px;
            bottom: -29px;
        }

        .notebook img{
            width: 70%;
        }
    }
    
</style>

<script>
import MediaPlay from '@/components/MediaPlay.vue?v=4';
import AdvantagesOfBeingAnAssociate from '@/components/AdvantagesOfBeingAnAssociate.vue?v=4';
import FormHaveAFranchisee from '@/components/FormHaveAFranchisee.vue?v=4';
import Emojis from '@/components/Emojis.vue';
export default {
    name:"associated",
    data() {
        return {
            
        }
    },
    components:{
        MediaPlay,
        AdvantagesOfBeingAnAssociate,
        FormHaveAFranchisee,
        Emojis
    },
    mounted() {
        this.$ga.page('/seja-um-franqueado')
    },
}
</script>